import * as React from "react";
import MuiTextField, {
    TextFieldProps as MuiTextFieldProps
} from "@mui/material/TextField";

const CustomTextField = React.forwardRef<
    HTMLInputElement,
    MuiTextFieldProps & { counter?: boolean }
>((props, forwardedRef) => {
    const { counter = false, onFocus, onBlur, helperText, value, slotProps, ...other } = props;

    const currentLength = typeof value === "string" ? value.length : 0;
    const maxLength = slotProps?.htmlInput?.["maxLength"];
    const isOverLimit = maxLength !== undefined && currentLength > maxLength-1;

    // 1. Create a local ref that we are guaranteed to control
    const internalInputRef = React.useRef<HTMLInputElement | null>(null);

    // 2. A unified setter function to handle both our local ref and the form manager ref
    const setRefs = React.useCallback((node: HTMLInputElement | null) => {
        internalInputRef.current = node; // Update our local tracking

        if (!forwardedRef) return;
        if (typeof forwardedRef === "function") {
            forwardedRef(node); // Handle callback refs (React Hook Form style)
        } else {
            forwardedRef.current = node; // Handle object refs ({ current: node })
        }
    }, [forwardedRef]);

    // 3. This will now run flawlessly on every keystroke
    React.useEffect(() => {
        const input = internalInputRef.current;
        if (input) {
            if (isOverLimit) {
                input.setCustomValidity("הטקסט חורג ממגבלת התווים");
            } else {
                input.setCustomValidity("");
            }
        }
    }, [isOverLimit, value]);

    return (
        <MuiTextField
            // 4. Pass our custom combined ref function here
            inputRef={setRefs} 
            value={value}
            slotProps={slotProps}
            {...other}
            helperText={counter && maxLength -1 !== undefined ? `${currentLength} / ${maxLength -1}` : helperText}
            error={isOverLimit || other.error}
        />
    );
});

CustomTextField.displayName = "CustomTextField";

export default CustomTextField;

